/* Sondur Travel — avaliações do widget (acervo da referência num asset JSON; a mesma marcação do widget de origem,
   sem script nem iframe do app). "Load More" acrescenta 5 por clique, como lá. */
(function () {
  'use strict';
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function data(iso) {
    var d = new Date(iso); if (isNaN(d)) return '';
    var m = ('0' + (d.getMonth() + 1)).slice(-2), dd = ('0' + d.getDate()).slice(-2);
    return m + '/' + dd + '/' + d.getFullYear();
  }
  function estrelas(n) {
    var s = ''; for (var i = 1; i <= 5; i++) s += '<span class="jdgm-star jdgm--' + (i <= n ? 'on' : 'off') + '"></span>';
    return s;
  }
  function review(r) {
    var dt = data(r.date);
    return '<div class="jdgm-rev jdgm-divider-top jdgm--done-setup" data-verified-buyer="' + (r.verified ? 'true' : 'false') + '" data-review-id="' + esc(r.id) + '" data-review-language="" data-product-title="' + esc(r.product_title) + '" data-thumb-up-count="0" data-thumb-down-count="0">' +
      ' <div class="jdgm-rev__header"> <div class="jdgm-rev__icon"> ' + esc(r.icon || (r.author || '?').charAt(0)) + ' </div> ' +
      '<span class="jdgm-rev__rating" data-score="' + r.score + '" tabindex="0" aria-label="' + r.score + ' star review" role="img"> ' + estrelas(r.score) + ' </span> ' +
      '<time class="jdgm-rev__timestamp" datetime="' + esc(r.date) + '" data-content="' + esc(r.date) + '">' + dt + '</time> <span class="jdgm-rev__pinned"></span> <div class="jdgm-rev__br"></div> ' +
      '<span class="jdgm-rev__buyer-badge-wrapper"> <span class="jdgm-rev__buyer-badge"></span> </span> ' +
      '<span class="jdgm-rev__author-wrapper"> <span class="jdgm-rev__author">' + esc(r.author) + '</span> <span class="jdgm-rev__location"> </span> </span> </div> ' +
      '<div class="jdgm-rev__content"> <div class="jdgm-rev__custom-form"> </div> <b class="jdgm-rev__title">' + esc(r.title) + '</b> <div class="jdgm-rev__body">' + r.body + '</div> ' +
      '<div class="jdgm-rev__pics"> </div> <div class="jdgm-rev__vids"> </div> <div class="jdgm-rev__transparency-badge-wrapper"> <div class="jdgm-rev__transparency-badge" data-badge-type="review_collected_from_store_visitor"></div> </div> </div> ' +
      '<div class="jdgm-rev__actions"> <div class="jdgm-rev__social"></div> <div class="jdgm-rev__votes"></div> </div> <div class="jdgm-rev__reply"> </div> </div>';
  }
  // o widget de origem marca o tamanho pela largura do contêiner (classes --small/--medium): a folha de estilo depende delas
  function tamanho() {
    var w = document.querySelector('.jdgm-review-widget'); if (!w) return;
    var x = w.getBoundingClientRect().width;
    w.classList.toggle('jdgm-review-widget--small', x < 560);
    w.classList.toggle('jdgm-review-widget--medium', x >= 560 && x < 800);
    // no widget de origem o botão "Write a review" da linha das estrelas só aparece nos tamanhos pequeno/médio
    // (a marcação capturada diz se o botão fica visível no tamanho grande: estilo inline vazio = visível sempre)
    var wr = w.querySelector('.jdgm-row-stars .jdgm-write-rev-link');
    if (wr) { if (wr._sdIni === undefined) wr._sdIni = wr.style.display !== 'none'; wr.style.display = (wr._sdIni || x < 800) ? '' : 'none'; }
  }
  function init() {
    tamanho(); window.addEventListener('resize', tamanho);
    var pag = document.querySelector('.jdgm-paginate[data-sd-reviews]');
    if (!pag || pag._sd) return; pag._sd = 1;
    var btn = pag.querySelector('.jdgm-paginate__load-more');
    var lista = document.querySelector('.jdgm-rev-widg__reviews');
    var per = parseInt(pag.getAttribute('data-per-page') || '5', 10) || 5;
    var pagina = parseInt((btn && btn.getAttribute('data-page')) || '2', 10) || 2;
    var acervo = null;
    function carregar() {
      if (acervo) return Promise.resolve(acervo);
      return fetch(pag.getAttribute('data-sd-reviews')).then(function (r) { return r.json(); }).then(function (j) { acervo = j; return j; });
    }
    if (btn) btn.addEventListener('click', function (e) {
      e.preventDefault(); btn.setAttribute('aria-busy', 'true');
      carregar().then(function (j) {
        var ini = (pagina - 1) * per, fim = ini + per, html = '';
        var ja = {}; [].forEach.call(lista.querySelectorAll('[data-review-id]'), function (x) { ja[x.getAttribute('data-review-id')] = 1; });
        (j.reviews || []).slice(ini, fim).forEach(function (r) { if (!ja[r.id]) html += review(r); });
        lista.insertAdjacentHTML('beforeend', html);
        pagina += 1; btn.setAttribute('data-page', String(pagina)); btn.removeAttribute('aria-busy');
        if (fim >= (j.reviews || []).length) pag.style.display = 'none';
      });
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
